<!-- eslint-disable vue/no-v-html -->
<template>
    <div
        class="markdown-table-artifact"
        v-html="parsedData" />
</template>

<script>
import { renderMarkdown } from '@/common/marked/markdown.utils.js';

export default {
    props: {
        data: {
            type: String,
            required: true,
        },
    },
    computed: {
        parsedData () {
            if (!this.data) return '';

            return renderMarkdown(this.data);
        },
    },
};
</script>

<style lang="less">
.markdown-table-artifact {
    // Enable horizontal scroll for wide tables
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    table {
        width: 100%;
        border-collapse: separate; // keeps border-radius on the container
        border-spacing: 0;
        background: var(--palette-gray-0);
        border: 1px solid var(--palette-gray-20); // gray-200
        border-radius: 8px;
        box-shadow: 0 1px 2px var(--semantic-drop-shadow-base);
    }

    caption {
        caption-side: top;
        text-align: left;
        font-size: 0.875rem;
        color: var(--palette-gray-90); // gray-500
        padding: 8px 4px 10px;
    }

    th,
    td {
        padding: 10px 12px;
        text-align: left;
        vertical-align: top;
        border-right: 1px solid var(--palette-gray-20); // cell divider
        border-bottom: 1px solid var(--palette-gray-20);
        font-size: 1.5rem;
        line-height: 1.4;
    }

    thead th {
        background: var(--palette-gray-10);
        color: var(--palette-gray-80);
        font-weight: 600;
        position: sticky;
        top: 0;
        z-index: 1;
    }

    tr > :last-child {
        border-right: none;
    }

    // Zebra striping for readability
    tbody tr:nth-child(even) {
        background: var(--palette-gray-10);
    }

    // Row hover for focus
    tbody tr:hover {
        background: var(--palette-gray-20);
    }

    // Rounded corners on the table
    thead tr:first-child th:first-child {
        border-top-left-radius: 8px;
    }
    thead tr:first-child th:last-child {
        border-top-right-radius: 8px;
    }
    tbody tr:last-child td:first-child {
        border-bottom-left-radius: 8px;
    }
    tbody tr:last-child td:last-child {
        border-bottom-right-radius: 8px;
    }

    // Compact style when tables are very dense
    &.compact {
        th,
        td {
            padding: 6px 8px;
        }
        caption {
            font-size: 0.8rem;
        }
    }
}
</style>
